import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  ExpandMore,
  PictureAsPdf,
  Slideshow,
} from "@mui/icons-material";
import { audit } from "./auditStats.config";
import CustomCheckbox from "../../../../../../CustomForm/CustomCheckbox";

const AuditStatsReport = () => {
  const [showData, setShowData] = useState(false);

  const handleButtonClick = () => {
    setShowData(!showData);
  };

  const reportData = [
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
  ];

  return (
    <Box sx={{ my: 4 }}>
      {/* Toggle Button */}
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
        sx={{
          justifyContent: "flex-start",
          textAlign: "left",
          py: 1.5,
        }}
      >
        Audit Stats Report
      </Button>

      {/* Collapsible Content */}
      {showData && (
        <Card sx={{ mt: 3 }}>
          <CardContent>
            {/* Period + Zone Row */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Period*"
                  name="periodTime"
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Select Zone"
                  size="small"
                  defaultValue=""
                >
                  <MenuItem value="">Select Founder</MenuItem>
                  <MenuItem value="">Select Founder</MenuItem>
                  <MenuItem value="">Select Founder</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            {/* Audit Checkboxes */}
            <Grid
              container
              spacing={2}
              sx={{ py: 2, ml: 0.5 }}
            >
              {audit.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CustomCheckbox />
                    <Typography sx={{ ml: 1.5, mt: 0.5 }}>
                      {item}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Submit Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                py: 1,
                my: 3,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ px: 4 }}
              >
                View Report Details
              </Button>
            </Box>

            {/* Report Table */}
            <TableContainer component={Paper} variant="outlined">
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Generated Date Time
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Report From
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Report To
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Download
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.map((data, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{data.dateTime}</TableCell>
                      <TableCell>{data.reportFrom}</TableCell>
                      <TableCell>{data.reportTo}</TableCell>
                      <TableCell>
                        <Tooltip title="Download PowerPoint" arrow>
                          <IconButton
                            color="primary"
                            size="large"
                          >
                            <Slideshow fontSize="large" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download PDF" arrow>
                          <IconButton
                            color="primary"
                            size="large"
                          >
                            <PictureAsPdf fontSize="large" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default AuditStatsReport;